export const apmcData = [
    {
        "fieldNo": "01.",
        "sNo": 1,
        "fieldVal": "વાર્ષિક આવક - વર્ષ ૨૦૨૨ - ૨૦૨૩ (ફક્ત લાખમાં) (Annual Income - Year 2022-2023 ( In lacs only) ).",
        "response": [
            { 
                "responseType": "text", 
                "fieldName":"annualIncome2022",
                "responseVal": "annualIncome2022",
                "responseName": "Annual Income 2022-2023"
            }
        ],
    },
    {
        "fieldNo": "",
        "sNo": 2,
        "fieldVal": "બજાર સમિતિના તારીજ, સરવૈયાની નકલ - વર્ષ ૨૦૨૨ - ૨૦૨૩.(Copies of the audit reports of the Market Committee for 2022-2023) ( In lacs only).",
        "response": [
            { 
                "responseType": "file", 
                "fieldName":"copyOfMarketCommitteeAudit2022",
                "responseVal": "copyOfMarketCommitteeAudit2022",
                "responseName": "Market Committee Audit 2022-2023"
            }
        ],
    },
    {
        "fieldNo": "02.",
        "sNo": 3,
        "fieldVal": "વાર્ષિક આવક - વર્ષ ૨૦૨૩ - ૨૦૨૪ (ફક્ત લાખમાં) (Annual Income - Year 2023-2024 ( In lacs only). ",
        "response": [
            { 
                "responseType": "text", 
                "fieldName":"annualIncome2023",
                "responseVal": "annualIncome2023",
                "responseName": "Annual Income 2023-2024"
            }
        ],
    },
    {
        "fieldNo": "",
        "sNo": 4,
        "fieldVal": "બજાર સમિતિના તારીજ, સરવૈયાની નકલ - વર્ષ ૨૦૨૩ - ૨૦૨૪.(Copies of the audit reports of the Market Committee for 2023-2024)( In lacs only).",
        "response": [
            { 
                "responseType": "file", 
                "fieldName":"copyOfMarketCommitteeAudit2023",
                "responseVal": "copyOfMarketCommitteeAudit2023",
                "responseName": "Copy Of Market Committee Audit 2023-2024"
            }
        ],
    },
    {
        "fieldNo": "03.",
        "sNo": 5,
        "fieldVal": "વાર્ષિક આવક - વર્ષ ૨૦૨૪ - ૨૦૨૫ (ફક્ત લાખમાં) (Annual Income - Year 2024 - 2025 ( In lacs only) ).",
        "response": [
            { 
                "responseType": "text", 
                "fieldName":"annualIncome2024",
                "responseVal": "annualIncome2024",
                "responseName": "Annual Income 2024-2025"
            }
        ],
    },
    {
        "fieldNo": "",
        "sNo": 6,
        "fieldVal": "બજાર સમિતિના તારીજ, સરવૈયાની નકલ - વર્ષ ૨૦૨૪ - ૨૦૨૫. (Copies of the audit reports of the Market Committee for 2024-2025) (In lacs only).",
        "response": [
            { 
                "responseType": "file", 
                "fieldName":"copyOfMarketCommitteeAudit2024",
                "responseVal": "copyOfMarketCommitteeAudit2024",
                "responseName": "Copy Of Market Committee Audit 2024-2025"
            }
        ],
    },
]
